import { usePasswordPolicy } from '@/hooks/usePasswordPolicy';
import { CheckCircle, XCircle } from 'lucide-react';

interface PasswordStrengthIndicatorProps {
  password: string;
}

export const PasswordStrengthIndicator = ({ password }: PasswordStrengthIndicatorProps) => {
  const { getPasswordRequirements, isSimpleMode } = usePasswordPolicy();
  const requirements = getPasswordRequirements();
  
  const checkRequirement = (requirement: string): boolean => {
    if (requirement.includes('6 characters')) {
      return password.length >= 6;
    }
    if (requirement.includes('8 characters')) {
      return password.length >= 8;
    }
    if (requirement.includes('uppercase')) {
      return /[A-Z]/.test(password);
    }
    if (requirement.includes('lowercase')) {
      return /[a-z]/.test(password);
    }
    if (requirement.includes('number')) {
      return /\d/.test(password);
    }
    if (requirement.includes('Maximum 128')) {
      return password.length <= 128;
    }
    return false;
  };

  return (
    <div className="space-y-2">
      <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
        Password Requirements {isSimpleMode ? '(Simple Mode)' : '(Complex Mode)'}:
      </div>
      <div className="space-y-1">
        {requirements.map((requirement, index) => {
          const isValid = checkRequirement(requirement);
          return (
            <div key={index} className="flex items-center space-x-2 text-sm">
              {isValid ? (
                <CheckCircle className="w-4 h-4 text-green-500" />
              ) : (
                <XCircle className="w-4 h-4 text-red-500" />
              )}
              <span className={isValid ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'}>
                {requirement}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};